module.exports = __webpack_public_path__ + "img/verification_ok.393a0c15.svg";